module.exports = __webpack_public_path__ + "static/media/1.89d33218.jpg";